import { DeviceRow } from 'components/tables/data/device/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the manufacturer.
 */
export default function ManufacturerColumn({ data: { manufacturer } }: { data: DeviceRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {manufacturer}
    </P2Regular>
  );
}
